import { Box } from "@mui/material"
import "./styles/blog.scss";
import { PostService } from "../../services/post";
import { useEffect, useState } from "react";
import { IPostPreview } from "../../interfaces/posts";
import PreviewItem from "./components/preview";

const Blogs: React.FC<{selected?: string}> = ({ selected }) => {

    const instance = new PostService();

    const [posts, setPosts] = useState<IPostPreview[]>([]);

    const get = () => {
        instance.get_all(undefined, 1, selected)
        .then(data => {
            setPosts(data.items);
            console.log('posts', posts)
        })
        .catch(error => {})
    }

    useEffect(() => {
        get();
    }, []);
    useEffect(() => {
        get();
    }, [selected]);

    return (
        <Box component="div" className="box-list">
            <Box component="ul">
                {
                    Array.isArray(posts) ? posts?.map( post => (
                        <PreviewItem key={post.id} post={post}/>
                    )) : null
                }
            
   
            </Box>
        </Box>
    )
}

export default Blogs;